export default "__VITE_ASSET__X4RG7ZDZ__"